module.exports = __webpack_public_path__ + "img/map-hotel-active.769917fe.png";